import type { IntlShape } from '@cmg/i18n';

import type { FundItem } from '../../FundLevelDemand';

/**
 * Format ioi value based on its unit type
 */
export const formatDemandItemValue = (ioi: FundItem['iois'][number], intl: IntlShape) => {
  if (ioi.unitType === 'dollars') {
    return intl.formatNumber(ioi.dollars, {
      format: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  if (ioi.unitType === 'percentage') {
    return intl.formatNumber(ioi.percentage, { format: 'percent' });
  }

  if (ioi.unitType === 'shares') {
    return `${intl.formatNumber(ioi.shares, { format: 'integer' })} Shares`;
  }

  return '';
};
